
import React from 'react';
import { TeacherFormData } from '@/types/teacher.types';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface TeacherContactInfoFieldsProps {
  formData: TeacherFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  validationErrors?: {[key: string]: string};
}

const TeacherContactInfoFields: React.FC<TeacherContactInfoFieldsProps> = ({ 
  formData, 
  handleChange,
  validationErrors = {}
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            className={validationErrors.email ? "border-red-500" : ""}
            placeholder="Enter email address"
          />
          {validationErrors.email && (
            <p className="text-sm text-red-500">{validationErrors.email}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone">Phone</Label>
          <Input
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
            inputMode="tel"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="country">Country</Label>
          <Select 
            name="country" 
            value={formData.country} 
            onValueChange={(value) => {
              handleChange({
                target: { name: 'country', value }
              } as React.ChangeEvent<HTMLSelectElement>);
            }}
          >
            <SelectTrigger id="country">
              <SelectValue placeholder="Select country" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Afghanistan">Afghanistan</SelectItem>
              <SelectItem value="Pakistan">Pakistan</SelectItem>
              <SelectItem value="Iran">Iran</SelectItem>
              <SelectItem value="Tajikistan">Tajikistan</SelectItem>
              <SelectItem value="Uzbekistan">Uzbekistan</SelectItem>
              <SelectItem value="Turkmenistan">Turkmenistan</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="city">City</Label>
          <Input
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            inputMode="text"
            placeholder="Enter city name"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="address">Address</Label>
        <Textarea
          id="address"
          name="address"
          rows={3}
          className="w-full px-3 py-2 border rounded-md"
          value={formData.address}
          onChange={handleChange}
          placeholder="Enter full address"
        ></Textarea>
      </div>
    </div>
  );
};

export default TeacherContactInfoFields;
